import { Injectable } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';

export interface FileUploadProgress {
    name: string;
    progress: number;
}

@Injectable({
    providedIn: 'root',
})
export class FlowloadFileUploadService {
    public importActive: Record<string, boolean> = {};
    public importProgressBars: Record<string, FileUploadProgress[]> = {};
    constructor() {}

    public setImportActive(caseStudyId: string, value: boolean): void {
        this.importActive[caseStudyId] = value;
    }

    public resetImport(caseStudyId: string): void {
        this.setImportActive(caseStudyId, false);
        this.importProgressBars[caseStudyId] = [];
    }

    public setProgressBars(uploader: FileUploader, caseStudyId: string): void {
        this.importProgressBars[caseStudyId] = [];
        for (let i = 0; i < uploader.queue.length; i++) {
            this.importProgressBars[caseStudyId].push({ name: uploader.queue[i]['file']['name'], progress: 0 });
        }
        uploader.onProgressItem = (file: FileItem, progress: number) => {
            const progressElement = this.importProgressBars[caseStudyId].find(
                (up) => up['name'] == file['file']['name'],
            );
            if (progressElement) {
                progressElement['progress'] = progress;
            }
        };
    }
}
